// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__RaK27","wrapper":"Section_wrapper__GC6p_","container":"Section_container__Ryzty","spin":"Section_spin__T7lQa","loader":"Section_loader__ZVZX6"};